(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-benefit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-benefit-coupon')) {
    customElements.define('bf-benefit-coupon', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-bfb-copy]')) {
          this.initialize();
        } else {
          this.initFrame = requestAnimationFrame(() => this.initialize());
        }
      }
      initialize() {
        if (!this.isConnected) return;
        this.button = this.querySelector('[data-bfb-copy]');
        if (!this.button) return;
        this.label = this.querySelector('[data-bfb-copy-label]');
        this.status = this.querySelector('[data-bfb-status]');
        this.originalLabel = this.button.dataset.label || this.label.textContent;
        this.label.textContent = this.originalLabel;
        this.handleCopy = this.copy.bind(this);
        this.button.addEventListener('click', this.handleCopy);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.resetTimer);
        if (this.button) this.button.removeEventListener('click', this.handleCopy);
        if (this.label) this.label.textContent = this.originalLabel;
        if (this.status) this.status.textContent = '';
      }
      legacyCopy(code) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
        document.body.appendChild(field);
        let copied = false;
        try {
          field.select();
          copied = document.execCommand('copy');
        } finally {
          field.remove();
        }
        return copied;
      }
      async copy() {
        const code = this.button.dataset.code;
        if (!code || this.button.disabled) return;
        clearTimeout(this.resetTimer);
        this.label.textContent = this.originalLabel;
        this.status.textContent = '';
        const previousFocus = document.activeElement;
        this.button.disabled = true;
        let copied = false;
        let usedLegacy = false;
        const fallback = () => { usedLegacy = true; return this.legacyCopy(code); };
        try {
          if (navigator.clipboard && window.isSecureContext) {
            try {
              await navigator.clipboard.writeText(code);
              copied = true;
            } catch (_) { copied = fallback(); }
          } else { copied = fallback(); }
        } catch (_) { copied = false; }
        if (!this.isConnected) { this.button.disabled = false; return; }
        this.button.disabled = false;
        if (usedLegacy || (previousFocus === this.button && document.activeElement === document.body)) {
          this.button.focus({ preventScroll: true });
        }
        if (copied) {
          this.label.textContent = this.button.dataset.copied || 'Copied!';
          this.status.textContent = this.label.textContent;
          this.resetTimer = setTimeout(() => {
            this.label.textContent = this.originalLabel;
            this.status.textContent = '';
          }, 2500);
        } else {
          this.label.textContent = this.button.dataset.manual || 'Select code';
          this.status.textContent = this.button.dataset.error || 'Please select and copy the code above.';
          const codeText = this.querySelector('[data-bfb-code-text]');
          const selection = window.getSelection();
          if (codeText && selection) {
            const range = document.createRange();
            range.selectNodeContents(codeText);
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-free-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-free-order')) {
    class BFFreeOrder extends HTMLElement {
      static scrollOwners = new Set();
      static previousOverflow = '';
      static previousOverflowPriority = '';

      connectedCallback() {
        this.onClick = this.handleClick.bind(this);
        this.onClose = this.handleClose.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('close', this.onClose, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('close', this.onClose, true);
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
        this.unlockScroll();
        this.opener = null;
      }

      handleClick(event) {
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        const opener = event.target.closest('[data-rules-open]');
        if (opener) {
          if (dialog.open || opener.disabled) return;
          this.opener = opener;
          dialog.showModal();
          this.lockScroll();
          return;
        }
        if (event.target.closest('[data-rules-close]')) {
          dialog.close();
          return;
        }
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      }

      handleClose(event) {
        if (!event.target.matches('.bffo__dialog') || event.target.open) return;
        this.unlockScroll();
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      lockScroll() {
        const owners = BFFreeOrder.scrollOwners;
        if (owners.has(this)) return;
        if (owners.size === 0) {
          const style = document.documentElement.style;
          BFFreeOrder.previousOverflow = style.getPropertyValue('overflow');
          BFFreeOrder.previousOverflowPriority = style.getPropertyPriority('overflow');
          style.setProperty('overflow', 'hidden', 'important');
        }
        owners.add(this);
      }

      unlockScroll() {
        const owners = BFFreeOrder.scrollOwners;
        if (!owners.delete(this) || owners.size > 0) return;
        const style = document.documentElement.style;
        if (BFFreeOrder.previousOverflow) {
          style.setProperty('overflow', BFFreeOrder.previousOverflow, BFFreeOrder.previousOverflowPriority);
        } else {
          style.removeProperty('overflow');
        }
      }
    }
    customElements.define('bf-free-order', BFFreeOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sihoo-us-bf-grid')) {
    customElements.define('sihoo-us-bf-grid', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const tabs = Array.from(this.querySelectorAll('[data-series-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-series-panel]'));
        const descElement = this.querySelector('[data-series-description]');
        const activate = (series, focus = false) => {
          tabs.forEach(tab => {
            const selected = tab.dataset.seriesTab === series;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            if (selected && focus) tab.focus();
          });
          panels.forEach(panel => { panel.hidden = panel.dataset.seriesPanel !== series; });
          if (descElement) {
            const description = tabs.find(tab => tab.dataset.seriesTab === series)?.dataset.tabDescription || '';
            descElement.textContent = description;
            descElement.hidden = !description;
          }
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab.dataset.seriesTab), options);
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 :
              (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            activate(tabs[next].dataset.seriesTab, true);
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const selectedTabBlock = event.target.closest('[data-series-tab]');
          if (selectedTabBlock) { activate(selectedTabBlock.dataset.seriesTab); return; }
          const card = event.target.closest('[data-sebf-card]');
          const panel = card?.closest('[data-series-panel]');
          if (panel) activate(panel.dataset.seriesPanel);
        }, options);

        this.querySelectorAll('[data-sebf-card]').forEach(card => {
          const data = document.getElementById(card.dataset.productDataId || '');
          if (!data) return;
          let product;
          try { product = JSON.parse(data.textContent); } catch (_) { return; }
          if (!Array.isArray(product?.variants) || !product.variants.length) return;
          card._sebfProduct = product;
          const selector = card.querySelector('[data-sebf-variant-select]');
          if (selector) {
            selector.addEventListener('change', () => this.updateCard(card, true), options);
          }
          this.updateCard(card, false);
        });
        this.addEventListener('click', event => {
          const checkoutButton = event.target.closest('[data-sebf-checkout]');
          if (!checkoutButton || !this.contains(checkoutButton)) return;
          event.preventDefault();
          if (!checkoutButton.disabled) this.handleCheckout(checkoutButton);
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      updateCard(card, changeImage) {
        const product = card._sebfProduct;
        if (!product) return;
        const selector = card.querySelector('[data-sebf-variant-select]');
        const variantId = selector?.value || card.querySelector('[data-sebf-variant-id]')?.value;
        const variant = product.variants.find(item => String(item.id) === String(variantId));
        if (!variant) return;
        card._sebfVariant = variant;
        const variantInput = card.querySelector('[data-sebf-variant-id]');
        const price = card.querySelector('[data-sebf-price]');
        const compare = card.querySelector('[data-sebf-compare]');
        const badge = card.querySelector('[data-sebf-badge]');
        const badgeNumber = card.querySelector('[data-sebf-badge-number]');
        const add = card.querySelector('[data-sebf-add]');
        const checkout = card.querySelector('[data-sebf-checkout]');
        const error = card.querySelector('[data-sebf-error]');
        if (variantInput) variantInput.value = String(variant.id);
        if (price) price.textContent = variant.price_formatted || '';
        if (compare) {
          compare.textContent = variant.compare_formatted || '';
          compare.hidden = !variant.compare_formatted;
        }
        if (badge) {
          badge.hidden = !variant.badge_show;
          badge.setAttribute('aria-label', `${variant.badge_text || ''} OFF`);
        }
        if (badgeNumber) badgeNumber.textContent = variant.badge_text || '';
        if (add) {
          add.disabled = !variant.available;
          add.textContent = variant.available ? (this.dataset.addLabel === 'Quick Add' ? 'Add to Cart' : this.dataset.addLabel || 'Add to Cart') : (this.dataset.soldOutLabel || 'Sold Out');
        }
        if (checkout) checkout.disabled = !variant.available;
        if (error) { error.textContent = ''; error.hidden = true; }

        // Maintain the selected variant on every product-detail link, including image and title.
        let url;
        try {
          url = new URL(product.url, window.location.origin);
          url.searchParams.set('variant', String(variant.id));
        } catch (_) { url = null; }
        if (url) card.querySelectorAll('[data-sebf-product-link]').forEach(link => {
          link.href = url.pathname + url.search + url.hash;
        });
        if (!changeImage) return; // Preserve merchant image overrides until a shopper changes SKU.
        const image = card.querySelector('.sebf__image');
        if (!image) return;
        const image900 = variant.image_900 || product.default_image_900;
        const image700 = variant.image_700 || product.default_image_700;
        const image450 = variant.image_450 || product.default_image_450;
        if (!image900) return;
        const source = card.querySelector('[data-sebf-picture-source]');
        if (source) source.srcset = `${image450 || image900} 450w, ${image700 || image900} 700w`;
        image.src = image900;
        image.srcset = `${image450 || image900} 450w, ${image700 || image900} 700w, ${image900} 900w`;
        image.alt = product.title + (variant.title && variant.title !== 'Default Title' ? ` - ${variant.title}` : '');
      }

      async handleCheckout(button) {
        const card = button.closest('[data-sebf-card]');
        const variant = card?._sebfVariant;
        const form = button.closest('form');
        if (!form || !variant?.available || button.dataset.busy === 'true') return;
        button.dataset.busy = 'true';
        const add = card.querySelector('[data-sebf-add]');
        const selector = card.querySelector('[data-sebf-variant-select]');
        const error = card.querySelector('[data-sebf-error]');
        const originalLabel = button.textContent;
        button.textContent = 'Processing...';
        button.disabled = true;
        if (add) add.disabled = true;
        if (selector) selector.disabled = true;
        if (error) { error.textContent = ''; error.hidden = true; }
        try {
          // Checkout is a separate action: add the exact selected variant via Shopify AJAX,
          // then redirect only on success. Do not trigger the Enterprise cart drawer.
          const baseAddUrl = this.dataset.cartAddUrl || '/cart/add';
          const addUrl = baseAddUrl.endsWith('.js') ? baseAddUrl : `${baseAddUrl.replace(/\/$/, '')}.js`;
          const response = await fetch(addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok || result.status || result.errors) {
            throw new Error(result.description || result.message || 'Unable to add this product.');
          }
          window.location.assign(this.dataset.checkoutUrl || '/checkout');
        } catch (err) {
          if (error) {
            error.textContent = err?.message || 'Unable to add this product. Please try again.';
            error.hidden = false;
          }
        } finally {
          button.dataset.busy = 'false';
          button.textContent = originalLabel;
          if (selector) selector.disabled = false;
          if (add) add.disabled = !variant.available;
          button.disabled = !variant.available;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-trustpilot"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bf-trustpilot')) return;

    class BFTrustpilot extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), {
            once: true,
            signal: this.controller.signal
          });
        } else this.initialize();
      }

      initialize() {
        if (!this.isConnected || !this.controller) return;
        const signal = this.controller.signal;
        this.viewport = this.querySelector('[data-bftp-viewport]');
        this.cards = Array.from(this.querySelectorAll('[data-bftp-review]'));
        this.previous = this.querySelector('[data-bftp-previous]');
        this.next = this.querySelector('[data-bftp-next]');
        this.position = this.querySelector('[data-bftp-position]');
        this.mobile = window.matchMedia('(max-width: 768px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;

        const hideBrokenAvatar = (image) => {
          if (image instanceof HTMLImageElement && image.classList.contains('bftp__avatar-image')) image.hidden = true;
        };
        this.addEventListener('error', (event) => hideBrokenAvatar(event.target), { capture: true, signal });
        this.querySelectorAll('.bftp__avatar-image').forEach((image) => {
          if (image.complete && image.naturalWidth === 0) hideBrokenAvatar(image);
        });
        if (!this.viewport || this.cards.length < 2) return;

        this.classList.add('is-enhanced');
        this.previous.addEventListener('click', () => this.goTo(this.activeIndex - 1), { signal });
        this.next.addEventListener('click', () => this.goTo(this.activeIndex + 1), { signal });
        this.viewport.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.readPosition());
        }, { passive: true, signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.goTo(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          if (!event.detail) return;
          const index = this.cards.findIndex((card) => card.dataset.blockId === String(event.detail.blockId));
          if (index >= 0) this.goTo(index, true);
        }, { signal });
        this.mobile.addEventListener('change', () => this.align(), { signal });
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.align());
        });
        this.resizeObserver.observe(this.viewport);
        this.readPosition();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        if (this.resizeObserver) this.resizeObserver.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.classList.remove('is-enhanced');
      }

      offsetFor(index) {
        const offset = this.cards[index].offsetLeft - this.cards[0].offsetLeft;
        return Math.min(offset, this.viewport.scrollWidth - this.viewport.clientWidth);
      }

      goTo(index, instant = false) {
        if (!this.mobile.matches) return;
        const target = Math.max(0, Math.min(this.cards.length - 1, index));
        this.viewport.scrollTo({
          left: this.offsetFor(target),
          behavior: instant || this.reducedMotion.matches ? 'auto' : 'smooth'
        });
        this.activeIndex = target;
        this.updateControls();
      }

      align() {
        if (this.mobile.matches) this.goTo(this.activeIndex, true);
        else {
          this.viewport.scrollLeft = 0;
          this.activeIndex = 0;
          this.updateControls();
        }
      }

      readPosition() {
        if (!this.mobile.matches) return;
        let index = 0;
        let nearest = Infinity;
        this.cards.forEach((card, candidate) => {
          const distance = Math.abs(this.offsetFor(candidate) - this.viewport.scrollLeft);
          if (distance < nearest) { nearest = distance; index = candidate; }
        });
        this.activeIndex = index;
        this.updateControls();
      }

      updateControls() {
        this.previous.disabled = this.activeIndex === 0;
        this.next.disabled = this.activeIndex === this.cards.length - 1;
        this.position.textContent = `${String(this.activeIndex + 1).padStart(2, '0')} / ${String(this.cards.length).padStart(2, '0')}`;
      }
    }

    customElements.define('bf-trustpilot', BFTrustpilot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('us-bf-v2-quick-buy')) {
    customElements.define('us-bf-v2-quick-buy', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.mobileQuery = window.matchMedia('(max-width: 768.98px)');
        this.posterWarmupReached = false;
        this.videoPlaybackTokens = new WeakMap();
        this.posterDecodePromises = new WeakMap();
        this.decodedPosters = new WeakSet();
        this.panels = Array.from(this.querySelectorAll('[data-desktop-panel]'));
        this.accordion = this.querySelector('[data-accordion]');
        this.accordionItems = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.desktopHotspots = Array.from(this.querySelectorAll('[data-desktop-hotspot]'));
        this.mobileHotspots = Array.from(this.querySelectorAll('[data-mobile-hotspot]'));
        this.back = this.querySelector('[data-cover-button]');
        this.status = this.querySelector('[data-status]');
        this.desktopCurrent = null;
        this.lastDesktopTrigger = null;
        this.lastMobileTrigger = null;
        this.modal = document.getElementById(this.dataset.modalId);
        if (this.modal) {
          this.modalPanel = this.modal.querySelector('[data-modal-panel]');
          this.modalScroll = this.modal.querySelector('[data-modal-scroll]');
          this.modalFeatures = Array.from(this.modal.querySelectorAll('[data-modal-feature]'));
          this.modalCount = this.modal.querySelector('[data-modal-count]');
          this.modalCurrent = null;
          this.availableMobile = this.mobileHotspots.filter(button => !button.disabled).map(button => button.dataset.blockId);
          this.modal.querySelector('[data-modal-prev]')?.addEventListener('click', () => this.stepModal(-1), opts);
          this.modal.querySelector('[data-modal-next]')?.addEventListener('click', () => this.stepModal(1), opts);
          this.modal.querySelector('[data-modal-close]')?.addEventListener('click', () => this.closeModal(), opts);
          this.modal.addEventListener('click', event => {
            if (event.target !== this.modal) return;
            const box = this.modalPanel?.getBoundingClientRect();
            if (!box || event.clientX < box.left || event.clientX > box.right ||
              event.clientY < box.top || event.clientY > box.bottom) this.closeModal();
          }, opts);
          this.modal.addEventListener('cancel', event => {
            event.preventDefault();
            this.closeModal();
          }, opts);
          this.modal.addEventListener('close', () => this.afterModalClose(), opts);
          this.modal.addEventListener('keydown', event => {
            if (!this.modal.open) return;
            if (event.key === 'Escape') {
              event.stopPropagation();
              return;
            }
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
            event.stopPropagation();
            event.preventDefault();
            this.stepModal(event.key === 'ArrowRight' ? 1 : -1);
          }, opts);

          let touchStart = null;
          this.modalScroll?.addEventListener('touchstart', event => {
            if (event.touches.length !== 1 || event.target.closest('video, a, button')) {
              touchStart = null;
              return;
            }
            touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchend', event => {
            if (!touchStart || !event.changedTouches.length) return;
            const dx = event.changedTouches[0].clientX - touchStart.x;
            const dy = event.changedTouches[0].clientY - touchStart.y;
            touchStart = null;
            if (Math.abs(dx) >= 55 && Math.abs(dx) > Math.abs(dy) * 1.35) {
              this.stepModal(dx < 0 ? 1 : -1);
            }
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchcancel', () => { touchStart = null; }, opts);
        }

        this.selectDesktop(null, false);
        this.addEventListener('click', event => {
          const pcHotspot = event.target.closest('[data-desktop-hotspot]');
          if (pcHotspot && !pcHotspot.disabled) {
            this.lastDesktopTrigger = pcHotspot;
            this.selectDesktop(pcHotspot.dataset.blockId);
            this.accordionItems.find(item => item.dataset.blockId === pcHotspot.dataset.blockId)
              ?.querySelector('[data-accordion-button]')?.focus({ preventScroll: true });
            return;
          }
          const accordionButton = event.target.closest('[data-accordion-button]');
          if (accordionButton && !accordionButton.disabled) {
            // Selecting an already-open detail keeps it open. Use Back to overview to close.
            this.selectDesktop(accordionButton.dataset.blockId);
            return;
          }
          if (event.target.closest('[data-cover-button]')) {
            this.returnToCover();
            return;
          }
          const mobileHotspot = event.target.closest('[data-mobile-hotspot]');
          if (mobileHotspot && !mobileHotspot.disabled) this.openModal(mobileHotspot.dataset.blockId, mobileHotspot);
        }, opts);

        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.desktopCurrent && !this.mobileQuery.matches) {
            event.preventDefault();
            this.returnToCover();
            return;
          }
          const button = event.target.closest('[data-accordion-button]');
          if (!button || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          const enabled = Array.from(this.querySelectorAll('[data-accordion-button]:not(:disabled)'));
          const index = enabled.indexOf(button);
          if (index < 0 || !enabled.length) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = enabled.length - 1;
          else nextIndex = (index + (event.key === 'ArrowDown' ? 1 : -1) + enabled.length) % enabled.length;
          enabled[nextIndex].focus();
          this.selectDesktop(enabled[nextIndex].dataset.blockId);
        }, opts);

        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail?.blockId;
          if (!blockId || !this.panels.some(panel => panel.dataset.blockId === blockId)) return;
          if (this.mobileQuery.matches) {
            const trigger = this.mobileHotspots.find(button => button.dataset.blockId === blockId);
            if (trigger && !trigger.disabled) this.openModal(blockId, trigger);
          } else {
            this.selectDesktop(blockId);
          }
        }, opts);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseAllVideos();
        }, opts);
        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', () => {
            if (!this.mobileQuery.matches) this.closeModal(true);
            else this.selectDesktop(null, false);
            // If the user rotates/resizes after approaching this section, hydrate only
            // the new device layout. Do not request the unused layout in advance.
            if (this.posterWarmupReached) this.preparePostersForCurrentDevice();
          }, opts);
        }
        if ('IntersectionObserver' in window) {
          // Pre-warm CDN still images around 500px before the section.
          // Video URLs remain inert in data-src until the shopper selects a feature.
          this.preloadObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.posterWarmupReached = true;
            this.preparePostersForCurrentDevice();
            this.preloadObserver?.disconnect();
          }, { rootMargin: '500px 0px', threshold: 0 });
          this.preloadObserver.observe(this);

          // Preserve the original behavior: pause desktop video when offscreen.
          this.observer = new IntersectionObserver(entries => {
            if (!entries[0]?.isIntersecting) this.pauseDesktopVideos();
          });
          this.observer.observe(this);
        } else {
          // Older browsers: prepare image posters, but keep video URLs deferred.
          this.posterWarmupReached = true;
          this.preparePostersForCurrentDevice();
        }
      }

      // CDN preview images can be fetched and decoded ahead of use without
      // initializing any video sources. Only the current device's posters are warmed.
      preparePostersForCurrentDevice() {
        const root = this.mobileQuery?.matches ? this.modal : this;
        const device = this.mobileQuery?.matches ? 'mobile' : 'desktop';
        root?.querySelectorAll(`[data-pbv-video="${device}"]`).forEach(video => {
          const image = video.closest('[data-pbv-video-shell]')?.querySelector('.pbv__video-placeholder img');
          this.preparePoster(image);
        });
      }

      // Resolve after the actual image is decoded, rather than merely having
      // a network request in progress. Promise is cached for repeat hotspot visits.
      preparePoster(image) {
        if (!image) return Promise.resolve(false);
        const existing = this.posterDecodePromises.get(image);
        if (existing) return existing;
        image.loading = 'eager';
        image.decoding = 'async';
        const decoded = new Promise(resolve => {
          const finish = loaded => {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
            if (!loaded) { resolve(false); return; }
            if (typeof image.decode === 'function') {
              image.decode().then(() => resolve(true)).catch(() => resolve(image.naturalWidth > 0));
            } else {
              resolve(true);
            }
          };
          const onLoad = () => finish(image.naturalWidth > 0);
          const onError = () => finish(false);
          if (image.complete) finish(image.naturalWidth > 0);
          else {
            image.addEventListener('load', onLoad, { once: true });
            image.addEventListener('error', onError, { once: true });
          }
        });
        const tracked = decoded.then(ready => {
          if (ready) this.decodedPosters.add(image);
          return ready;
        });
        this.posterDecodePromises.set(image, tracked);
        return tracked;
      }

      // Adapted from ra-video-gallery-01: actual CDN source URLs are stored in
      // data-src and set on <source> elements only on a feature click.
      activateVideoSource(video) {
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.removeAttribute('controls');
        if (video.dataset.poster && !video.hasAttribute('poster')) {
          video.setAttribute('poster', video.dataset.poster);
        }
        video.preload = 'auto';
        const deferredSources = video.querySelectorAll('source[data-src]');
        if (!deferredSources.length) return; // Already hydrated. Never call load() again.
        deferredSources.forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
      }

      // Only reveal moving footage once the browser has rendered a real decoded frame.
      // A thumbnail stays visible during buffering, unsupported autoplay and load failures.
      revealOnFirstFrame(video, token) {
        const shell = video.closest('[data-pbv-video-shell]');
        if (!shell) return;
        const reveal = () => {
          if (this.videoPlaybackTokens.get(video) !== token || video.paused || video.readyState < 2) return;
          if (shell.closest('[hidden]') || document.hidden) return;
          shell.classList.add('is-video-ready');
          const panel = video.closest('[data-desktop-panel]');
          if (panel && this.desktopCurrent === panel.dataset.blockId) {
            panel.style.visibility = '';
            this.toggleAttribute('data-feature-media-active', true);
          }
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(reveal);
        } else {
          // Older Safari: wait for actual playback, then allow two paint frames.
          const afterPlayback = () => {
            requestAnimationFrame(() => requestAnimationFrame(reveal));
          };
          video.addEventListener('playing', afterPlayback, { once: true, signal: this.controller.signal });
          video.addEventListener('timeupdate', afterPlayback, { once: true, signal: this.controller.signal });
          if (!video.paused && video.currentTime > 0 && video.readyState >= 2) afterPlayback();
        }
      }

      // Keep the existing overview visible until either the selected item's
      // CDN poster has decoded or its first real video frame has been rendered.
      // This also handles a shopper jumping straight to this section by anchor.
      revealDesktopPanelWithPoster(panel, blockId) {
        const shell = panel?.querySelector('[data-pbv-video-shell]');
        if (!shell) return; // Non-video feature image keeps its original behavior.
        const preview = shell.querySelector('.pbv__video-placeholder img');
        if (preview && this.decodedPosters.has(preview)) return;
        panel.style.visibility = 'hidden';
        this.toggleAttribute('data-feature-media-active', false);
        this.preparePoster(preview).then(ready => {
          if (!ready || this.desktopCurrent !== blockId || panel.hidden) return;
          panel.style.visibility = '';
          this.toggleAttribute('data-feature-media-active', true);
        });
      }

      playVideo(video) {
        if (!video || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const token = (this.videoPlaybackTokens.get(video) || 0) + 1;
        this.videoPlaybackTokens.set(video, token);
        const shell = video.closest('[data-pbv-video-shell]');
        shell?.classList.remove('is-video-ready');
        // A newly opened mobile modal also requests its image first if the
        // section was reached before the 500px preload observer fired.
        this.preparePoster(shell?.querySelector('.pbv__video-placeholder img'));
        this.activateVideoSource(video);
        this.revealOnFirstFrame(video, token);
        const promise = video.play();
        promise?.catch(() => { /* Thumbnail remains visible if playback fails. */ });
      }

      selectDesktop(blockId, announce = true) {
        const panel = this.panels.find(item => item.dataset.blockId === blockId);
        this.pauseDesktopVideos();
        this.desktopCurrent = panel ? blockId : null;
        const hasMedia = Boolean(panel && panel.dataset.hasMedia === 'true');
        this.toggleAttribute('data-feature-active', Boolean(panel));
        this.toggleAttribute('data-feature-media-active', hasMedia);
        this.panels.forEach(item => {
          item.hidden = !hasMedia || item !== panel;
          item.style.visibility = '';
        });
        if (panel && hasMedia) this.revealDesktopPanelWithPoster(panel, blockId);
        if (this.accordion) this.accordion.hidden = !panel;
        if (this.back) this.back.hidden = !panel;
        this.accordionItems.forEach(item => {
          const active = Boolean(panel && item.dataset.blockId === blockId);
          item.classList.toggle('is-active', active);
          const button = item.querySelector('[data-accordion-button]');
          const content = item.querySelector('[data-accordion-description]');
          if (button) button.setAttribute('aria-expanded', String(active));
          if (content) content.hidden = !active;
        });
        if (announce && this.status) {
          const button = this.accordionItems.find(item => item.dataset.blockId === blockId)?.querySelector('[data-accordion-button]');
          this.status.textContent = panel ? (button?.textContent || 'Feature').trim() : 'Back to overview';
        }
        this.playVideo(panel?.querySelector('video'));
      }

      returnToCover() {
        this.selectDesktop(null);
        if (this.lastDesktopTrigger?.isConnected) this.lastDesktopTrigger.focus({ preventScroll: true });
      }

      openModal(blockId, trigger) {
        if (!this.mobileQuery?.matches || !this.modal || !this.availableMobile.includes(blockId)) return;
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }
        const wasOpen = this.modal.open;
        const wasInteractive = this.modal.classList.contains('is-open');
        if (!wasOpen) {
          this.lastMobileTrigger = trigger || null;
          try {
            this.modal.showModal();
          } catch (_) {
            return;
          }
        }
        this.showModalFeature(blockId, 1);
        requestAnimationFrame(() => {
          if (!this.isConnected || !this.modal?.open) return;
          this.modal.classList.add('is-open');
          if (!wasInteractive) this.playVideo(this.modalFeatures?.find(item => item.dataset.blockId === blockId)?.querySelector('video'));
          if (!wasOpen) this.modalPanel?.focus({ preventScroll: true });
        });
      }

      showModalFeature(blockId, direction) {
        const feature = this.modalFeatures?.find(item => item.dataset.blockId === blockId);
        if (!feature) return;
        this.pauseModalVideos();
        this.modalCurrent = blockId;
        this.modal.dataset.direction = direction < 0 ? 'prev' : 'next';
        this.modalFeatures.forEach(item => {
          item.hidden = item !== feature;
          item.classList.remove('is-entering');
        });
        feature.classList.add('is-entering');
        this.modal.setAttribute('aria-labelledby', feature.querySelector('.pbv__modal-title')?.id || '');
        const index = this.availableMobile.indexOf(blockId);
        if (this.modalCount) this.modalCount.textContent = `${index + 1} / ${this.availableMobile.length}`;
        if (this.modalScroll) this.modalScroll.scrollTop = 0;
        if (this.status) this.status.textContent = feature.querySelector('.pbv__modal-title')?.textContent?.trim() || 'Product feature';
        if (this.modal.classList.contains('is-open')) this.playVideo(feature.querySelector('video'));
      }

      stepModal(step) {
        if (!this.modal?.open || !this.availableMobile.length) return;
        const index = this.availableMobile.indexOf(this.modalCurrent);
        const next = (Math.max(0, index) + step + this.availableMobile.length) % this.availableMobile.length;
        this.showModalFeature(this.availableMobile[next], step);
      }

      closeModal(immediate = false) {
        if (!this.modal?.open) return;
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.modal.classList.remove('is-open');
        this.pauseModalVideos();
        const finish = () => {
          this.closeTimer = null;
          if (this.modal?.open) this.modal.close();
        };
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else this.closeTimer = window.setTimeout(finish, 180);
      }

      afterModalClose() {
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.modal?.classList.remove('is-open');
        this.pauseModalVideos();
        const trigger = this.lastMobileTrigger;
        if (trigger?.isConnected && this.mobileQuery?.matches) trigger.focus({ preventScroll: true });
        this.lastMobileTrigger = null;
        this.modalCurrent = null;
      }

      pauseVideo(video) {
        this.videoPlaybackTokens?.set(video, (this.videoPlaybackTokens.get(video) || 0) + 1);
        video.pause();
      }
      pauseDesktopVideos() { this.panels?.forEach(panel => panel.querySelectorAll('video').forEach(video => this.pauseVideo(video))); }
      pauseModalVideos() { this.modal?.querySelectorAll('video').forEach(video => this.pauseVideo(video)); }
      pauseAllVideos() { this.pauseDesktopVideos(); this.pauseModalVideos(); }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.preloadObserver?.disconnect();
        this.pauseAllVideos();
        if (this.modal?.open) this.modal.close();
        this.modal?.classList.remove('is-open');
        document.getElementById(this.dataset.quickBuyId || '')?.remove();
      }
    });
  }

  if (!customElements.get('us-bf-v2-quick-buy-drawer')) {
    class PreBfQuickBuy extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        if (this._initialized) return;
        this._initialized = true;
        this._controller = new AbortController();
        const opts = { signal: this._controller.signal };
        this._panel = this.querySelector('[data-pbq-panel]');
        this._title = this.querySelector('[data-pbq-title]');
        this._image = this.querySelector('[data-pbq-image]');
        this._priceRow = this.querySelector('[data-pbq-price-row]');
        this._price = this.querySelector('[data-pbq-price]');
        this._comparePrice = this.querySelector('[data-pbq-compare-price]');
        this._options = this.querySelector('[data-pbq-options]');
        this._status = this.querySelector('[data-pbq-status]');
        this._checkoutButton = this.querySelector('[data-pbq-checkout]');
        this._addButton = this.querySelector('[data-pbq-add]');
        this._success = this.querySelector('[data-pbq-success]');
        this._successProduct = this.querySelector('[data-pbq-success-product]');
        this._onDocumentClick = (event) => {
          const trigger = event.target.closest?.('[data-pbq-trigger]');
          if (!trigger || trigger.dataset.pbqDrawerId !== this.id) return;
          const dataNode = document.getElementById(trigger.dataset.pbqProductDataId || '');
          if (!dataNode) return;
          try {
            this.product = JSON.parse(dataNode.textContent || '{}');
          } catch (error) {
            this._setStatus('Product options could not be loaded. Please try again.', true);
            return;
          }
          if (!this.product || !Array.isArray(this.product.variants) || !this.product.variants.length) {
            this._setStatus('This product has no selectable variants.', true);
            return;
          }
          this.opener = trigger;
          this.initialVariantId = trigger.dataset.pbqInitialVariantId || '';
          this._renderProduct();
          this.open();
        };
        this._onClick = (event) => {
          if (event.target.closest?.('[data-pbq-close]')) {
            event.preventDefault();
            this.close();
            return;
          }
          const optionButton = event.target.closest?.('[data-pbq-option-index]');
          if (optionButton && this.contains(optionButton)) {
            const index = Number(optionButton.dataset.pbqOptionIndex);
            this.selectedOptions[index] = optionButton.dataset.pbqOptionValue;
            this._renderOptions();
            this._syncVariant();
            return;
          }
          if (event.target.closest?.('[data-pbq-add]')) {
            event.preventDefault();
            this._addToCart();
            return;
          }
          if (event.target.closest?.('[data-pbq-checkout]')) {
            event.preventDefault();
            this._checkoutSelectedVariant();
            return;
          }
        };
        this._onKeydown = (event) => {
          if (!this._isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;
          const focusable = Array.from(this._panel.querySelectorAll('a[href]:not([hidden]), button:not(:disabled):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])'))
            .filter((node) => node.getAttribute('aria-hidden') !== 'true');
          if (!focusable.length) {
            event.preventDefault();
            this._panel.focus();
            return;
          }
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        };
        document.addEventListener('click', this._onDocumentClick, opts);
        document.addEventListener('keydown', this._onKeydown, opts);
        this.addEventListener('click', this._onClick, opts);
      }

      disconnectedCallback() {
        this._controller?.abort();
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._initialized = false;
      }

      open() {
        this._resetSuccess();
        document.querySelectorAll('us-bf-v2-quick-buy-drawer.is-open').forEach((drawer) => {
          if (drawer !== this && typeof drawer.close === 'function') drawer.close(false);
        });
        // Do not show a second drawer behind the merchant's own Quick Add panel.
        const nativeCartDrawer = document.querySelector('cart-drawer[open]');
        if (nativeCartDrawer && typeof nativeCartDrawer.close === 'function') nativeCartDrawer.close();
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this.hidden = false;
        this.setAttribute('aria-hidden', 'false');
        this._isOpen = true;
        requestAnimationFrame(() => this.classList.add('is-open'));
        requestAnimationFrame(() => this.querySelector('[data-pbq-close]')?.focus({ preventScroll: true }));
      }

      close(restoreFocus = true) {
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._closeTimer = null;
        this._resetSuccess();
        if (!this._isOpen) return;
        this._isOpen = false;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        this._closeTimer = setTimeout(() => {
          if (!this._isOpen) this.hidden = true;
          this._closeTimer = null;
        }, 230);
        if (restoreFocus && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }

      _renderProduct() {
        this._resetSuccess();
        this._title.textContent = this.product.title || 'Choose a product';
        this._status.textContent = '';
        this._status.classList.remove('is-error');
        const initial = this.product.variants.find((variant) => String(variant.id) === String(this.initialVariantId));
        const variant = initial || this.product.variants.find((item) => item.available) || this.product.variants[0];
        this.selectedOptions = Array.isArray(variant.options) ? [...variant.options] : [];
        this.currentVariant = variant;
        this._renderOptions();
        this._syncVariant();
      }

      _renderOptions() {
        this._options.innerHTML = '';
        const optionNames = Array.isArray(this.product.options) ? this.product.options : [];
        const isDefaultTitle = optionNames.length === 1 && String(optionNames[0]).toLowerCase() === 'title';
        if (!optionNames.length || isDefaultTitle) {
          this._options.hidden = true;
          return;
        }
        this._options.hidden = false;
        const anyAvailable = this.product.variants.some((variant) => variant.available);
        optionNames.forEach((optionName, index) => {
          const values = [...new Set(this.product.variants.map((variant) => variant.options?.[index]).filter((value) => typeof value === 'string' && value.length))];
          if (!values.length) return;
          const group = document.createElement('fieldset');
          group.className = 'pbq__option-group';
          const legend = document.createElement('legend');
          legend.className = 'pbq__option-legend';
          legend.textContent = optionName;
          group.appendChild(legend);
          const valueWrap = document.createElement('div');
          valueWrap.className = 'pbq__option-values';
          const isColor = /(?:colou?r|farbe)/i.test(optionName);
          values.forEach((value) => {
            const compatible = this.product.variants.some(variant => variant.available && variant.options?.[index] === value);
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pbq__option-value';
            if (isColor) button.classList.add('pbq__option-value--color');
            const selected = this.selectedOptions[index] === value;
            if (selected) button.classList.add('is-selected');
            button.setAttribute('aria-pressed', String(selected));
            button.dataset.pbqOptionIndex = String(index);
            button.dataset.pbqOptionValue = value;
            button.textContent = value;
            if (isColor) {
              button.textContent = '';
              const swatch = document.createElement('span');
              swatch.className = 'pbq__swatch';
              swatch.style.backgroundColor = this._colorForValue(value);
              swatch.setAttribute('aria-hidden', 'true');
              const label = document.createElement('span');
              label.textContent = value;
              button.append(swatch, label);
            }
            button.disabled = anyAvailable && !compatible;
            valueWrap.appendChild(button);
          });
          group.appendChild(valueWrap);
          this._options.appendChild(group);
        });
      }

      _colorForValue(value) {
        const normalized = String(value).toLowerCase().trim();
        const colors = {
          black: '#222222', schwarz: '#222222',
          white: '#ffffff', weiss: '#ffffff', 'weiß': '#ffffff',
          grey: '#8c8c8c', gray: '#8c8c8c', grau: '#8c8c8c',
          silver: '#c6c8ca', silber: '#c6c8ca',
          blue: '#3f6fa7', blau: '#3f6fa7', navy: '#1c2c4b', marineblau: '#1c2c4b',
          red: '#b32b2b', rot: '#b32b2b',
          brown: '#76513a', braun: '#76513a',
          beige: '#d8c4a1', cream: '#f3e8d0', creme: '#f3e8d0',
          pink: '#e5a9bd', rosa: '#e5a9bd',
          green: '#497451', gruen: '#497451', 'grün': '#497451',
          purple: '#75559b', lila: '#75559b', violett: '#75559b',
          orange: '#e18a37', yellow: '#f0cf3a', gelb: '#f0cf3a'
        };
        return colors[normalized] || '#bdbdbd';
      }

      _syncVariant() {
        const variant = this.product.variants.find((item) => Array.isArray(item.options) && item.options.length === this.selectedOptions.length && item.options.every((value, index) => value === this.selectedOptions[index]));
        this.currentVariant = variant || null;
        if (variant) {
          const imageUrl = variant.image || this.product.image;
          if (imageUrl) {
            this._image.src = imageUrl;
            this._image.alt = `${this.product.title || ''}${variant.title ? ` - ${variant.title}` : ''}`.trim();
            this._image.hidden = false;
          } else {
            this._image.removeAttribute('src');
            this._image.hidden = true;
          }
        }
        const hasPrice = Boolean(variant && variant.price_formatted);
        this._priceRow.hidden = !hasPrice;
        this._price.innerHTML = hasPrice ? variant.price_formatted : ''; // Shopify native price-as-money snippet only
        const hasComparePrice = Boolean(hasPrice && Number(variant.compare_at_price) > Number(variant.price) && variant.compare_at_price_formatted);
        this._comparePrice.hidden = !hasComparePrice;
        this._comparePrice.innerHTML = hasComparePrice ? variant.compare_at_price_formatted : ''; // Shopify native price-as-money snippet only
        if (!variant) this._setStatus('This option combination is unavailable.', true);
        else if (!variant.available) this._setStatus('This option is sold out. Please choose another option.', true);
        else this._setStatus('', false);
        this._addButton.disabled = !variant || !variant.available || this._adding;
        this._checkoutButton.disabled = !variant || !variant.available || this._adding;
      }

      _checkoutSelectedVariant() {
        const variant = this.currentVariant;
        if (!variant || !variant.available || this._adding) return;
        const variantId = String(variant.id || '');
        if (!/^\d+$/.test(variantId)) {
          this._setStatus('Unable to open checkout for this option. Please try again.', true);
          return;
        }
        // Preserve the original one-SKU direct checkout behavior. This is intentionally
        // different from checking out every item already in the shopper's cart.
        // Shopify's localized routes.cart_url supplies the US storefront prefix.
        const cartRoute = this.dataset.cartUrl || window.theme?.routes?.cart || '/cart';
        const cartPath = new URL(cartRoute, window.location.origin).pathname.replace(/\/+$/, '');
        this._checkoutButton.disabled = true;
        this._checkoutButton.textContent = 'Redirecting...';
        window.location.assign(`${window.location.origin}${cartPath}/${variantId}:1`);
      }

      _setStatus(message, isError = false) {
        if (!this._status) return;
        this._status.textContent = message || '';
        this._status.classList.toggle('is-error', Boolean(isError));
      }

      async _addToCart() {
        const variant = this.currentVariant;
        if (!variant || !variant.available || this._adding) return;
        this._adding = true;
        const originalLabel = this._addButton.textContent;
        this._addButton.disabled = true;
        this._checkoutButton.disabled = true;
        this._addButton.classList.add('is-loading');
        this._addButton.textContent = 'Adding...';
        this._setStatus('', false);
        let added = false;
        try {
          // The custom UI owns open/close/success. The Enterprise API owns cart data.
          const enterprise = window.theme || {};
          const cartUrl = enterprise.routes?.cart || this.dataset.cartUrl || '/cart';
          const cartJsonUrl = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl.replace(/\/$/, '')}.js`;
          const rawAddUrl = enterprise.routes?.cartAdd || this.dataset.cartAddUrl || '/cart/add';
          const cartAddUrl = rawAddUrl.endsWith('.js') ? rawAddUrl : `${rawAddUrl.replace(/\/$/, '')}.js`;
          let oldCartData = null;
          try {
            const oldResponse = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } });
            if (oldResponse.ok) oldCartData = await oldResponse.json();
          } catch (_) { /* Cart comparison is optional and must not block a sale. */ }

          const formData = new FormData();
          formData.append('id', String(variant.id));
          formData.append('quantity', '1');
          const sections = ['cart-icon-bubble'];
          const cartDrawer = document.querySelector('cart-drawer');
          const drawerSectionId = cartDrawer?.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '');
          if (drawerSectionId && !sections.includes(drawerSectionId)) sections.push(drawerSectionId);
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);

          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const data = await response.json();
          let errorMessage = typeof data.description === 'string'
            ? data.description
            : (data.message || 'Unable to add this item. Please try again.');
          if (data.errors && typeof data.errors === 'object') {
            errorMessage = Object.values(data.errors)
              .map(value => Array.isArray(value) ? value.join(', ') : String(value))
              .join(', ');
          }
          if (!response.ok || data.status || data.errors) throw new Error(errorMessage);
          added = true;

          // Silently refresh the native Enterprise cart. Never open its drawer.
          // Keep the success state even if the optional UI refresh fails.
          try {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble && data.sections?.['cart-icon-bubble']) {
              bubble.innerHTML = data.sections['cart-icon-bubble'];
            }
            if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
              await cartDrawer.renderContents(data, false);
            } else if (cartDrawer) {
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            }
            const cartItems = document.querySelector('cart-items');
            if (cartItems && typeof cartItems.refresh === 'function') cartItems.refresh();
          } catch (_) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          }

          const addedVariantId = Number(data.variant_id || variant.id);
          const previous = oldCartData?.items?.find(item => Number(item.variant_id) === addedVariantId);
          if (previous) {
            this.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                variantId: addedVariantId,
                oldQuantity: previous.quantity,
                newQuantity: previous.quantity + 1
              }
            }));
          } else {
            this.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: { variantId: addedVariantId }
            }));
          }
          // Preserve event names already used by the US BFCM custom Quick Add.
          this.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: [{ id: addedVariantId, quantity: 1 }] }
          }));
          this.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: data }
          }));
          this._showSuccessThenClose();
        } catch (error) {
          const message = error?.message || 'Unable to add this item. Please try again.';
          this._setStatus(message, true);
          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: { error: message }
          }));
        } finally {
          this._adding = false;
          this._addButton.classList.remove('is-loading');
          this._addButton.textContent = originalLabel || 'Add to Cart';
          this._addButton.disabled = !this.currentVariant || !this.currentVariant.available;
          this._checkoutButton.disabled = !this.currentVariant || !this.currentVariant.available;
          if (added) this._setStatus('', false);
        }
      }

      _showSuccessThenClose() {
        if (!this._success) {
          this.close();
          return;
        }
        if (this._successProduct) this._successProduct.textContent = this.product?.title || '';
        this._success.hidden = false;
        this._panel.classList.add('has-success');
        this._success.focus({ preventScroll: true });
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._closeTimer = setTimeout(() => {
          this._closeTimer = null;
          this.close();
        }, 1200);
      }

      _resetSuccess() {
        if (this._success) this._success.hidden = true;
        if (this._panel) this._panel.classList.remove('has-success');
      }
    }
    customElements.define('us-bf-v2-quick-buy-drawer', PreBfQuickBuy);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-free-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-bf-free-order')) {
    class PreBfFreeOrder extends HTMLElement {
      // One shared lock for all instances, including simultaneous modal dialogs.
      static scrollOwners = new Set();
      static previousOverflow = '';
      static previousOverflowPriority = '';

      connectedCallback() {
        this.onClick = this.handleClick.bind(this);
        this.onClose = this.handleClose.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('close', this.onClose, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('close', this.onClose, true);
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
        this.unlockScroll();
        this.opener = null;
      }

      handleClick(event) {
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        const opener = event.target.closest('[data-rules-open]');
        if (opener) {
          if (dialog.open) return;
          this.opener = opener;
          dialog.showModal();
          this.lockScroll();
          return;
        }
        if (event.target.closest('[data-rules-close]')) {
          dialog.close();
          return;
        }
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            dialog.close();
          }
        }
      }

      handleClose(event) {
        if (!event.target.matches('.pbfo__dialog') || event.target.open) return;
        this.unlockScroll();
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      lockScroll() {
        const owners = PreBfFreeOrder.scrollOwners;
        if (owners.has(this)) return;
        if (owners.size === 0) {
          const style = document.documentElement.style;
          PreBfFreeOrder.previousOverflow = style.getPropertyValue('overflow');
          PreBfFreeOrder.previousOverflowPriority = style.getPropertyPriority('overflow');
          style.setProperty('overflow', 'hidden', 'important');
        }
        owners.add(this);
      }

      unlockScroll() {
        const owners = PreBfFreeOrder.scrollOwners;
        if (!owners.delete(this) || owners.size > 0) return;
        const style = document.documentElement.style;
        if (PreBfFreeOrder.previousOverflow) {
          style.setProperty('overflow', PreBfFreeOrder.previousOverflow, PreBfFreeOrder.previousOverflowPriority);
        } else {
          style.removeProperty('overflow');
        }
      }
    }
    customElements.define('pre-bf-free-order', PreBfFreeOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-subscribe-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-bf-subscribe-popup')) {
    class PreBfSubscribePopup extends HTMLElement {
      static scrollOwners = new Set();
      static previousOverflow = '';
      static previousOverflowPriority = '';

      connectedCallback() {
        if (this.isConnectedToEvents) return;
        this.isConnectedToEvents = true;
        this.onClick = this.handleClick.bind(this);
        this.onClose = this.handleClose.bind(this);
        this.onScroll = this.queueVisibility.bind(this);
        this.addEventListener('click', this.onClick);
        // The dialog's close event does not bubble, so capture it.
        this.addEventListener('close', this.onClose, true);
        if (this.dataset.triggerMode === 'scroll') {
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
        this.visibilityFrame = requestAnimationFrame(() => this.syncVisibility());
      }

      disconnectedCallback() {
        if (!this.isConnectedToEvents) return;
        this.isConnectedToEvents = false;
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('close', this.onClose, true);
        window.removeEventListener('scroll', this.onScroll);
        if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
        this.visibilityFrame = null;
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
        this.unlockScroll();
        this.opener = null;
      }

      queueVisibility() {
        if (this.visibilityFrame) return;
        this.visibilityFrame = requestAnimationFrame(() => this.syncVisibility());
      }

      syncVisibility() {
        this.visibilityFrame = null;
        const floating = this.querySelector('[data-pbsp-floating]');
        if (!floating) return;
        if (this.dataset.triggerMode !== 'scroll') {
          floating.classList.add('is-visible');
          return;
        }
        const threshold = Number(this.dataset.scrollThreshold) || 0;
        floating.classList.toggle('is-visible', window.scrollY >= threshold);
      }

      handleClick(event) {
        const minimize = event.target.closest('[data-pbsp-minimize]');
        if (minimize && this.contains(minimize)) {
          const floating = this.querySelector('[data-pbsp-floating]');
          if (floating) floating.classList.add('is-minimized');
          return;
        }
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        const opener = event.target.closest('[data-pbsp-open]');
        if (opener && this.contains(opener)) {
          if (dialog.open) return;
          this.opener = opener;
          dialog.showModal();
          this.lockScroll();
          requestAnimationFrame(() => {
            if (!dialog.open) return;
            const field = dialog.querySelector('input[type="email"]');
            const closeButton = dialog.querySelector('[data-pbsp-close]');
            const focusTarget = field && !field.disabled ? field : closeButton;
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          });
          return;
        }
        if (event.target.closest('[data-pbsp-close]')) {
          dialog.close();
          return;
        }
        if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
      }

      handleClose(event) {
        if (!event.target.matches('.pbsp__dialog') || event.target.open) return;
        this.unlockScroll();
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      lockScroll() {
        const owners = PreBfSubscribePopup.scrollOwners;
        if (owners.has(this)) return;
        if (!owners.size) {
          const style = document.documentElement.style;
          PreBfSubscribePopup.previousOverflow = style.getPropertyValue('overflow');
          PreBfSubscribePopup.previousOverflowPriority = style.getPropertyPriority('overflow');
          style.setProperty('overflow', 'hidden', 'important');
        }
        owners.add(this);
      }

      unlockScroll() {
        const owners = PreBfSubscribePopup.scrollOwners;
        if (!owners.delete(this) || owners.size) return;
        const style = document.documentElement.style;
        if (PreBfSubscribePopup.previousOverflow) {
          style.setProperty('overflow', PreBfSubscribePopup.previousOverflow, PreBfSubscribePopup.previousOverflowPriority);
        } else {
          style.removeProperty('overflow');
        }
      }
    }
    customElements.define('pre-bf-subscribe-popup', PreBfSubscribePopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-bf-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-bf-v2')) {
    customElements.define('pre-bf-v2', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.mobileQuery = window.matchMedia('(max-width: 768.98px)');
        this.posterWarmupReached = false;
        this.videoPlaybackTokens = new WeakMap();
        this.posterDecodePromises = new WeakMap();
        this.decodedPosters = new WeakSet();
        this.panels = Array.from(this.querySelectorAll('[data-desktop-panel]'));
        this.accordion = this.querySelector('[data-accordion]');
        this.accordionItems = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.desktopHotspots = Array.from(this.querySelectorAll('[data-desktop-hotspot]'));
        this.mobileHotspots = Array.from(this.querySelectorAll('[data-mobile-hotspot]'));
        this.back = this.querySelector('[data-cover-button]');
        this.status = this.querySelector('[data-status]');
        this.desktopCurrent = null;
        this.lastDesktopTrigger = null;
        this.lastMobileTrigger = null;
        this.modal = document.getElementById(this.dataset.modalId);
        if (this.modal) {
          document.body.appendChild(this.modal);
          this.modalIsPortaled = true;
          this.modalPanel = this.modal.querySelector('[data-modal-panel]');
          this.modalScroll = this.modal.querySelector('[data-modal-scroll]');
          this.modalFeatures = Array.from(this.modal.querySelectorAll('[data-modal-feature]'));
          this.modalCount = this.modal.querySelector('[data-modal-count]');
          this.modalCurrent = null;
          this.availableMobile = this.mobileHotspots.filter(button => !button.disabled).map(button => button.dataset.blockId);
          this.modal.querySelector('[data-modal-prev]')?.addEventListener('click', () => this.stepModal(-1), opts);
          this.modal.querySelector('[data-modal-next]')?.addEventListener('click', () => this.stepModal(1), opts);
          this.modal.querySelector('[data-modal-close]')?.addEventListener('click', () => this.closeModal(), opts);
          this.modal.addEventListener('click', event => {
            if (event.target === this.modal) this.closeModal();
          }, opts);

          let touchStart = null;
          this.modalScroll?.addEventListener('touchstart', event => {
            if (event.touches.length !== 1 || event.target.closest('video, a, button')) {
              touchStart = null;
              return;
            }
            touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchend', event => {
            if (!touchStart || !event.changedTouches.length) return;
            const dx = event.changedTouches[0].clientX - touchStart.x;
            const dy = event.changedTouches[0].clientY - touchStart.y;
            touchStart = null;
            if (Math.abs(dx) >= 55 && Math.abs(dx) > Math.abs(dy) * 1.35) {
              this.stepModal(dx < 0 ? 1 : -1);
            }
          }, { ...opts, passive: true });
          this.modalScroll?.addEventListener('touchcancel', () => { touchStart = null; }, opts);
        }

        this.selectDesktop(null, false);
        this.addEventListener('click', event => {
          const pcHotspot = event.target.closest('[data-desktop-hotspot]');
          if (pcHotspot && !pcHotspot.disabled) {
            this.lastDesktopTrigger = pcHotspot;
            this.selectDesktop(pcHotspot.dataset.blockId);
            this.accordionItems.find(item => item.dataset.blockId === pcHotspot.dataset.blockId)
              ?.querySelector('[data-accordion-button]')?.focus({ preventScroll: true });
            return;
          }
          const accordionButton = event.target.closest('[data-accordion-button]');
          if (accordionButton && !accordionButton.disabled) {
            // Selecting an already-open detail keeps it open. Use Back to overview to close.
            this.selectDesktop(accordionButton.dataset.blockId);
            return;
          }
          if (event.target.closest('[data-cover-button]')) {
            this.returnToCover();
            return;
          }
          const mobileHotspot = event.target.closest('[data-mobile-hotspot]');
          if (mobileHotspot && !mobileHotspot.disabled) this.openModal(mobileHotspot.dataset.blockId, mobileHotspot);
        }, opts);

        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.desktopCurrent && !this.mobileQuery.matches) {
            event.preventDefault();
            this.returnToCover();
            return;
          }
          const button = event.target.closest('[data-accordion-button]');
          if (!button || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          const enabled = Array.from(this.querySelectorAll('[data-accordion-button]:not(:disabled)'));
          const index = enabled.indexOf(button);
          if (index < 0 || !enabled.length) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = enabled.length - 1;
          else nextIndex = (index + (event.key === 'ArrowDown' ? 1 : -1) + enabled.length) % enabled.length;
          enabled[nextIndex].focus();
          this.selectDesktop(enabled[nextIndex].dataset.blockId);
        }, opts);

        document.addEventListener('keydown', event => {
          if (!this.modal || this.modal.hidden) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeModal();
          } else if (event.key === 'Tab') {
            this.trapModalFocus(event);
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
            event.preventDefault();
            this.stepModal(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, opts);
        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail?.blockId;
          if (!blockId || !this.panels.some(panel => panel.dataset.blockId === blockId)) return;
          if (this.mobileQuery.matches) {
            const trigger = this.mobileHotspots.find(button => button.dataset.blockId === blockId);
            if (trigger && !trigger.disabled) this.openModal(blockId, trigger);
          } else {
            this.selectDesktop(blockId);
          }
        }, opts);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseAllVideos();
        }, opts);
        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', () => {
            if (!this.mobileQuery.matches) this.closeModal(true);
            else this.selectDesktop(null, false);
            // If the user rotates/resizes after approaching this section, hydrate only
            // the new device layout. Do not request the unused layout in advance.
            if (this.posterWarmupReached) this.preparePostersForCurrentDevice();
          }, opts);
        }
        if ('IntersectionObserver' in window) {
          // Pre-warm CDN still images around 500px before the section.
          // Video URLs remain inert in data-src until the shopper selects a feature.
          this.preloadObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.posterWarmupReached = true;
            this.preparePostersForCurrentDevice();
            this.preloadObserver?.disconnect();
          }, { rootMargin: '500px 0px', threshold: 0 });
          this.preloadObserver.observe(this);

          // Preserve the original behavior: pause desktop video when offscreen.
          this.observer = new IntersectionObserver(entries => {
            if (!entries[0]?.isIntersecting) this.pauseDesktopVideos();
          });
          this.observer.observe(this);
        } else {
          // Older browsers: prepare image posters, but keep video URLs deferred.
          this.posterWarmupReached = true;
          this.preparePostersForCurrentDevice();
        }
      }

      // CDN preview images can be fetched and decoded ahead of use without
      // initializing any video sources. Only the current device's posters are warmed.
      preparePostersForCurrentDevice() {
        const root = this.mobileQuery?.matches ? this.modal : this;
        const device = this.mobileQuery?.matches ? 'mobile' : 'desktop';
        root?.querySelectorAll(`[data-pbv-video="${device}"]`).forEach(video => {
          const image = video.closest('[data-pbv-video-shell]')?.querySelector('.pbv__video-placeholder img');
          this.preparePoster(image);
        });
      }

      // Resolve after the actual image is decoded, rather than merely having
      // a network request in progress. Promise is cached for repeat hotspot visits.
      preparePoster(image) {
        if (!image) return Promise.resolve(false);
        const existing = this.posterDecodePromises.get(image);
        if (existing) return existing;
        image.loading = 'eager';
        image.decoding = 'async';
        const decoded = new Promise(resolve => {
          const finish = loaded => {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
            if (!loaded) { resolve(false); return; }
            if (typeof image.decode === 'function') {
              image.decode().then(() => resolve(true)).catch(() => resolve(image.naturalWidth > 0));
            } else {
              resolve(true);
            }
          };
          const onLoad = () => finish(image.naturalWidth > 0);
          const onError = () => finish(false);
          if (image.complete) finish(image.naturalWidth > 0);
          else {
            image.addEventListener('load', onLoad, { once: true });
            image.addEventListener('error', onError, { once: true });
          }
        });
        const tracked = decoded.then(ready => {
          if (ready) this.decodedPosters.add(image);
          return ready;
        });
        this.posterDecodePromises.set(image, tracked);
        return tracked;
      }

      // Adapted from ra-video-gallery-01: actual CDN source URLs are stored in
      // data-src and set on <source> elements only on a feature click.
      activateVideoSource(video) {
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.removeAttribute('controls');
        if (video.dataset.poster && !video.hasAttribute('poster')) {
          video.setAttribute('poster', video.dataset.poster);
        }
        video.preload = 'auto';
        const deferredSources = video.querySelectorAll('source[data-src]');
        if (!deferredSources.length) return; // Already hydrated. Never call load() again.
        deferredSources.forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
      }

      // Only reveal moving footage once the browser has rendered a real decoded frame.
      // A thumbnail stays visible during buffering, unsupported autoplay and load failures.
      revealOnFirstFrame(video, token) {
        const shell = video.closest('[data-pbv-video-shell]');
        if (!shell) return;
        const reveal = () => {
          if (this.videoPlaybackTokens.get(video) !== token || video.paused || video.readyState < 2) return;
          if (shell.closest('[hidden]') || document.hidden) return;
          shell.classList.add('is-video-ready');
          const panel = video.closest('[data-desktop-panel]');
          if (panel && this.desktopCurrent === panel.dataset.blockId) {
            panel.style.visibility = '';
            this.toggleAttribute('data-feature-media-active', true);
          }
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(reveal);
        } else {
          // Older Safari: wait for actual playback, then allow two paint frames.
          const afterPlayback = () => {
            requestAnimationFrame(() => requestAnimationFrame(reveal));
          };
          video.addEventListener('playing', afterPlayback, { once: true, signal: this.controller.signal });
          video.addEventListener('timeupdate', afterPlayback, { once: true, signal: this.controller.signal });
          if (!video.paused && video.currentTime > 0 && video.readyState >= 2) afterPlayback();
        }
      }

      // Keep the existing overview visible until either the selected item's
      // CDN poster has decoded or its first real video frame has been rendered.
      // This also handles a shopper jumping straight to this section by anchor.
      revealDesktopPanelWithPoster(panel, blockId) {
        const shell = panel?.querySelector('[data-pbv-video-shell]');
        if (!shell) return; // Non-video feature image keeps its original behavior.
        const preview = shell.querySelector('.pbv__video-placeholder img');
        if (preview && this.decodedPosters.has(preview)) return;
        panel.style.visibility = 'hidden';
        this.toggleAttribute('data-feature-media-active', false);
        this.preparePoster(preview).then(ready => {
          if (!ready || this.desktopCurrent !== blockId || panel.hidden) return;
          panel.style.visibility = '';
          this.toggleAttribute('data-feature-media-active', true);
        });
      }

      playVideo(video) {
        if (!video || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const token = (this.videoPlaybackTokens.get(video) || 0) + 1;
        this.videoPlaybackTokens.set(video, token);
        const shell = video.closest('[data-pbv-video-shell]');
        shell?.classList.remove('is-video-ready');
        // A newly opened mobile modal also requests its image first if the
        // section was reached before the 500px preload observer fired.
        this.preparePoster(shell?.querySelector('.pbv__video-placeholder img'));
        this.activateVideoSource(video);
        this.revealOnFirstFrame(video, token);
        const promise = video.play();
        promise?.catch(() => { /* Thumbnail remains visible if playback fails. */ });
      }

      selectDesktop(blockId, announce = true) {
        const panel = this.panels.find(item => item.dataset.blockId === blockId);
        this.pauseDesktopVideos();
        this.desktopCurrent = panel ? blockId : null;
        const hasMedia = Boolean(panel && panel.dataset.hasMedia === 'true');
        this.toggleAttribute('data-feature-active', Boolean(panel));
        this.toggleAttribute('data-feature-media-active', hasMedia);
        this.panels.forEach(item => {
          item.hidden = !hasMedia || item !== panel;
          item.style.visibility = '';
        });
        if (panel && hasMedia) this.revealDesktopPanelWithPoster(panel, blockId);
        if (this.accordion) this.accordion.hidden = !panel;
        if (this.back) this.back.hidden = !panel;
        this.accordionItems.forEach(item => {
          const active = Boolean(panel && item.dataset.blockId === blockId);
          item.classList.toggle('is-active', active);
          const button = item.querySelector('[data-accordion-button]');
          const content = item.querySelector('[data-accordion-description]');
          if (button) button.setAttribute('aria-expanded', String(active));
          if (content) content.hidden = !active;
        });
        if (announce && this.status) {
          const button = this.accordionItems.find(item => item.dataset.blockId === blockId)?.querySelector('[data-accordion-button]');
          this.status.textContent = panel ? (button?.textContent || 'Feature').trim() : 'Back to overview';
        }
        this.playVideo(panel?.querySelector('video'));
      }

      returnToCover() {
        this.selectDesktop(null);
        if (this.lastDesktopTrigger?.isConnected) this.lastDesktopTrigger.focus({ preventScroll: true });
      }

      openModal(blockId, trigger) {
        if (!this.mobileQuery?.matches || !this.modal || !this.availableMobile.includes(blockId)) return;
        if (this.closeTimer) clearTimeout(this.closeTimer);
        const wasHidden = this.modal.hidden;
        const wasOpen = this.modal.classList.contains('is-open');
        if (wasHidden || !wasOpen) {
          this.lastMobileTrigger = trigger || null;
          this.modal.hidden = false;
          this.lockScroll();
        }
        this.showModalFeature(blockId, 1);
        requestAnimationFrame(() => {
          if (!this.modal || this.modal.hidden) return;
          this.modal.classList.add('is-open');
          if (!wasOpen) this.playVideo(this.modalFeatures?.find(item => item.dataset.blockId === blockId)?.querySelector('video'));
          if (wasHidden) this.modalPanel?.focus({ preventScroll: true });
        });
      }

      showModalFeature(blockId, direction) {
        const feature = this.modalFeatures?.find(item => item.dataset.blockId === blockId);
        if (!feature) return;
        this.pauseModalVideos();
        this.modalCurrent = blockId;
        this.modal.dataset.direction = direction < 0 ? 'prev' : 'next';
        this.modalFeatures.forEach(item => {
          item.hidden = item !== feature;
          item.classList.remove('is-entering');
        });
        feature.classList.add('is-entering');
        this.modal.setAttribute('aria-labelledby', feature.querySelector('.pbv__modal-title')?.id || '');
        const index = this.availableMobile.indexOf(blockId);
        if (this.modalCount) this.modalCount.textContent = `${index + 1} / ${this.availableMobile.length}`;
        if (this.modalScroll) this.modalScroll.scrollTop = 0;
        if (this.status) this.status.textContent = feature.querySelector('.pbv__modal-title')?.textContent?.trim() || 'Product feature';
        if (this.modal.classList.contains('is-open')) this.playVideo(feature.querySelector('video'));
      }

      stepModal(step) {
        if (!this.modal || this.modal.hidden || !this.availableMobile.length) return;
        const index = this.availableMobile.indexOf(this.modalCurrent);
        const next = (Math.max(0, index) + step + this.availableMobile.length) % this.availableMobile.length;
        this.showModalFeature(this.availableMobile[next], step);
      }

      closeModal(immediate = false) {
        if (!this.modal || this.modal.hidden) return;
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.modal.classList.remove('is-open');
        this.pauseModalVideos();
        this.unlockScroll();
        const trigger = this.lastMobileTrigger;
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.modal.hidden = true;
          if (!immediate && trigger?.isConnected) trigger.focus({ preventScroll: true });
        } else {
          this.closeTimer = window.setTimeout(() => {
            if (this.modal) this.modal.hidden = true;
            if (trigger?.isConnected && this.mobileQuery.matches) trigger.focus({ preventScroll: true });
            this.closeTimer = null;
          }, 180);
        }
        this.lastMobileTrigger = null;
      }

      lockScroll() {
        if (this.scrollLocked) return;
        this.previousOverflow = document.body.style.overflow;
        this.previousPaddingRight = document.body.style.paddingRight;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
        this.scrollLocked = true;
      }
      unlockScroll() {
        if (!this.scrollLocked) return;
        document.body.style.overflow = this.previousOverflow;
        document.body.style.paddingRight = this.previousPaddingRight;
        this.scrollLocked = false;
      }
      trapModalFocus(event) {
        const nodes = Array.from(this.modal.querySelectorAll('button:not(:disabled), a[href], [tabindex]:not([tabindex="-1"])'));
        const focusable = nodes.filter(node => !node.closest('[hidden]') && node.getClientRects().length);
        if (!focusable.length) { event.preventDefault(); this.modalPanel?.focus(); return; }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.modalPanel)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
      pauseVideo(video) {
        this.videoPlaybackTokens?.set(video, (this.videoPlaybackTokens.get(video) || 0) + 1);
        video.pause();
      }
      pauseDesktopVideos() { this.panels?.forEach(panel => panel.querySelectorAll('video').forEach(video => this.pauseVideo(video))); }
      pauseModalVideos() { this.modal?.querySelectorAll('video').forEach(video => this.pauseVideo(video)); }
      pauseAllVideos() { this.pauseDesktopVideos(); this.pauseModalVideos(); }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.preloadObserver?.disconnect();
        this.pauseAllVideos();
        this.unlockScroll();
        if (this.modalIsPortaled) this.modal?.remove();
        document.getElementById(this.dataset.quickBuyId || '')?.remove();
      }
    });
  }

  if (!customElements.get('pre-bf-quick-buy')) {
    class PreBfQuickBuy extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        if (this._initialized) return;
        this._initialized = true;
        this._controller = new AbortController();
        const opts = { signal: this._controller.signal };
        this._panel = this.querySelector('[data-pbq-panel]');
        this._title = this.querySelector('[data-pbq-title]');
        this._image = this.querySelector('[data-pbq-image]');
        this._price = this.querySelector('[data-pbq-price]');
        this._options = this.querySelector('[data-pbq-options]');
        this._status = this.querySelector('[data-pbq-status]');
        this._learnMore = this.querySelector('[data-pbq-learn-more]');
        this._addButton = this.querySelector('[data-pbq-add]');
        this._success = this.querySelector('[data-pbq-success]');
        this._successProduct = this.querySelector('[data-pbq-success-product]');
        this._onDocumentClick = (event) => {
          const trigger = event.target.closest?.('[data-pbq-trigger]');
          if (!trigger || trigger.dataset.pbqDrawerId !== this.id) return;
          const dataNode = document.getElementById(trigger.dataset.pbqProductDataId || '');
          if (!dataNode) return;
          try {
            this.product = JSON.parse(dataNode.textContent || '{}');
          } catch (error) {
            this._setStatus('Product options could not be loaded. Please try again.', true);
            return;
          }
          if (!this.product || !Array.isArray(this.product.variants) || !this.product.variants.length) {
            this._setStatus('This product has no selectable variants.', true);
            return;
          }
          this.opener = trigger;
          this.initialVariantId = trigger.dataset.pbqInitialVariantId || '';
          this._renderProduct();
          this.open();
        };
        this._onClick = (event) => {
          if (event.target.closest?.('[data-pbq-close]')) {
            event.preventDefault();
            this.close();
            return;
          }
          const optionButton = event.target.closest?.('[data-pbq-option-index]');
          if (optionButton && this.contains(optionButton)) {
            const index = Number(optionButton.dataset.pbqOptionIndex);
            this.selectedOptions[index] = optionButton.dataset.pbqOptionValue;
            this._renderOptions();
            this._syncVariant();
            return;
          }
          if (event.target.closest?.('[data-pbq-add]')) {
            event.preventDefault();
            this._addToCart();
            return;
          }
          if (event.target.closest?.('[data-pbq-learn-more]')) this.close(false);
        };
        this._onKeydown = (event) => {
          if (!this._isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key !== 'Tab') return;
          const focusable = Array.from(this._panel.querySelectorAll('a[href]:not([hidden]), button:not(:disabled):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])'))
            .filter((node) => node.getAttribute('aria-hidden') !== 'true');
          if (!focusable.length) {
            event.preventDefault();
            this._panel.focus();
            return;
          }
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        };
        document.addEventListener('click', this._onDocumentClick, opts);
        document.addEventListener('keydown', this._onKeydown, opts);
        this.addEventListener('click', this._onClick, opts);
      }

      disconnectedCallback() {
        this._controller?.abort();
        if (this._closeTimer) clearTimeout(this._closeTimer);
        if (this._isOpen) this._unlockScroll();
        this._initialized = false;
      }

      open() {
        this._resetSuccess();
        document.querySelectorAll('pre-bf-quick-buy.is-open').forEach((drawer) => {
          if (drawer !== this && typeof drawer.close === 'function') drawer.close(false);
        });
        // Close the theme's native cart drawer if it happens to be open; this panel is the only drawer shown.
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.hidden = false;
        this.setAttribute('aria-hidden', 'false');
        this._isOpen = true;
        requestAnimationFrame(() => this.classList.add('is-open'));
        requestAnimationFrame(() => this.querySelector('[data-pbq-close]')?.focus({ preventScroll: true }));
      }

      close(restoreFocus = true) {
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._closeTimer = null;
        this._resetSuccess();
        if (!this._isOpen) return;
        this._isOpen = false;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        this._unlockScroll();
        this._closeTimer = setTimeout(() => {
          if (!this._isOpen) this.hidden = true;
          this._closeTimer = null;
        }, 230);
        if (restoreFocus && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }

      _unlockScroll() {
        document.body.style.overflow = this._previousBodyOverflow || '';
      }

      _renderProduct() {
        this._resetSuccess();
        this._title.textContent = this.product.title || 'Choose a product';
        this._status.textContent = '';
        this._status.classList.remove('is-error');
        const initial = this.product.variants.find((variant) => String(variant.id) === String(this.initialVariantId));
        const variant = initial || this.product.variants.find((item) => item.available) || this.product.variants[0];
        this.selectedOptions = Array.isArray(variant.options) ? [...variant.options] : [];
        this.currentVariant = variant;
        this._renderOptions();
        this._syncVariant();
      }

      _renderOptions() {
        this._options.innerHTML = '';
        const optionNames = Array.isArray(this.product.options) ? this.product.options : [];
        const isDefaultTitle = optionNames.length === 1 && String(optionNames[0]).toLowerCase() === 'title';
        if (!optionNames.length || isDefaultTitle) {
          this._options.hidden = true;
          return;
        }
        this._options.hidden = false;
        const anyAvailable = this.product.variants.some((variant) => variant.available);
        optionNames.forEach((optionName, index) => {
          const values = [...new Set(this.product.variants.map((variant) => variant.options?.[index]).filter((value) => typeof value === 'string' && value.length))];
          if (!values.length) return;
          const group = document.createElement('fieldset');
          group.className = 'pbq__option-group';
          const legend = document.createElement('legend');
          legend.className = 'pbq__option-legend';
          legend.textContent = optionName;
          group.appendChild(legend);
          const valueWrap = document.createElement('div');
          valueWrap.className = 'pbq__option-values';
          const isColor = /colou?r/i.test(optionName);
          values.forEach((value) => {
            const compatible = this.product.variants.some((variant) => variant.available && variant.options?.[index] === value && variant.options.every((candidate, candidateIndex) => candidateIndex === index || candidate === this.selectedOptions[candidateIndex]));
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pbq__option-value';
            if (isColor) button.classList.add('pbq__option-value--color');
            const selected = this.selectedOptions[index] === value;
            if (selected) button.classList.add('is-selected');
            button.setAttribute('aria-pressed', String(selected));
            button.dataset.pbqOptionIndex = String(index);
            button.dataset.pbqOptionValue = value;
            button.textContent = value;
            if (isColor) {
              button.textContent = '';
              const swatch = document.createElement('span');
              swatch.className = 'pbq__swatch';
              swatch.style.backgroundColor = this._colorForValue(value);
              swatch.setAttribute('aria-hidden', 'true');
              const label = document.createElement('span');
              label.textContent = value;
              button.append(swatch, label);
            }
            button.disabled = anyAvailable && !compatible;
            valueWrap.appendChild(button);
          });
          group.appendChild(valueWrap);
          this._options.appendChild(group);
        });
      }

      _colorForValue(value) {
        const normalized = String(value).toLowerCase().trim();
        const colors = {
          black: '#222222', white: '#ffffff', grey: '#8c8c8c', gray: '#8c8c8c',
          silver: '#c6c8ca', blue: '#3f6fa7', navy: '#1c2c4b', red: '#b32b2b',
          brown: '#76513a', beige: '#d8c4a1', cream: '#f3e8d0', pink: '#e5a9bd',
          green: '#497451', purple: '#75559b', orange: '#e18a37', yellow: '#f0cf3a'
        };
        return colors[normalized] || '#bdbdbd';
      }

      _syncVariant() {
        const variant = this.product.variants.find((item) => Array.isArray(item.options) && item.options.length === this.selectedOptions.length && item.options.every((value, index) => value === this.selectedOptions[index]));
        this.currentVariant = variant || null;
        if (variant) {
          const imageUrl = variant.image || this.product.image;
          if (imageUrl) {
            this._image.src = imageUrl;
            this._image.alt = `${this.product.title || ''}${variant.title ? ` - ${variant.title}` : ''}`.trim();
            this._image.hidden = false;
          } else {
            this._image.removeAttribute('src');
            this._image.hidden = true;
          }
        }
        const showPrice = this.dataset.showPrice === 'true';
        this._price.hidden = !(showPrice && variant && variant.price_formatted);
        this._price.textContent = this._price.hidden ? '' : variant.price_formatted;
        if (this._learnMore) {
          this._learnMore.hidden = !this.product.url;
          if (this.product.url) {
            try {
              const url = new URL(this.product.url, window.location.origin);
              if (variant) url.searchParams.set('variant', String(variant.id));
              this._learnMore.href = url.toString();
            } catch (_) {
              this._learnMore.href = this.product.url;
            }
          }
        }
        if (!variant) this._setStatus('This option combination is unavailable.', true);
        else if (!variant.available) this._setStatus('This option is sold out. Please choose another option.', true);
        else this._setStatus('', false);
        this._addButton.disabled = !variant || !variant.available || this._adding;
      }

      _setStatus(message, isError = false) {
        if (!this._status) return;
        this._status.textContent = message || '';
        this._status.classList.toggle('is-error', Boolean(isError));
      }

      async _addToCart() {
        const variant = this.currentVariant;
        if (!variant || !variant.available || this._adding) return;
        this._adding = true;
        const originalLabel = this._addButton.textContent;
        this._addButton.disabled = true;
        this._addButton.classList.add('is-loading');
        this._addButton.textContent = 'Adding...';
        this._setStatus('', false);
        let added = false;
        try {
          const theme = window.theme || {};
          const cartUrl = theme.routes?.cart || this.dataset.cartUrl || '/cart';
          const cartJsonUrl = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl.replace(/\/$/, '')}.js`;
          const rawAddUrl = theme.routes?.cartAdd || this.dataset.cartAddUrl || '/cart/add';
          const cartAddUrl = rawAddUrl.endsWith('.js') ? rawAddUrl : `${rawAddUrl.replace(/\/$/, '')}.js`;
          let oldCartData = null;
          try {
            const oldCartResponse = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } });
            if (oldCartResponse.ok) oldCartData = await oldCartResponse.json();
          } catch (_) { /* Adding must remain possible if the optional event comparison fails. */ }

          const formData = new FormData();
          formData.append('id', String(variant.id));
          formData.append('quantity', '1');
          const sections = ['cart-icon-bubble'];
          const cartDrawer = document.querySelector('cart-drawer');
          const drawerSectionId = cartDrawer?.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '');
          if (drawerSectionId && !sections.includes(drawerSectionId)) sections.push(drawerSectionId);
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);

          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const data = await response.json();
          let errorMessage = typeof data.description === 'string' ? data.description : (data.message || 'Unable to add this item. Please try again.');
          if (data.errors && typeof data.errors === 'object') {
            errorMessage = Object.values(data.errors).map((value) => Array.isArray(value) ? value.join(', ') : String(value)).join(', ');
          }
          if (!response.ok || data.status || data.errors) throw new Error(errorMessage);
          added = true;

          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble && data.sections?.['cart-icon-bubble']) cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
            try {
              // Refresh the native drawer HTML without opening it.
              await cartDrawer.renderContents(data, false);
            } catch (_) {
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            }
          }

          const addedVariantId = Number(data.variant_id || variant.id);
          const oldItem = oldCartData?.items?.find((item) => Number(item.variant_id) === addedVariantId);
          if (oldItem) {
            this.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                variantId: addedVariantId,
                oldQuantity: oldItem.quantity,
                newQuantity: (oldItem.quantity === data.quantity) ? oldItem.quantity : data.quantity
              }
            }));
          } else {
            this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: addedVariantId } }));
          }
          this.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: [{ id: addedVariantId, quantity: 1 }] }
          }));
          this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: data } }));

          this._showSuccessThenClose();
        } catch (error) {
          const message = error?.message || 'Unable to add this item. Please try again.';
          this._setStatus(message, true);
          this.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: message } }));
        } finally {
          this._adding = false;
          this._addButton.classList.remove('is-loading');
          this._addButton.textContent = originalLabel || 'Add to Cart';
          this._addButton.disabled = !this.currentVariant || !this.currentVariant.available;
          if (added) this._setStatus('', false);
        }
      }

      _showSuccessThenClose() {
        if (!this._success) {
          this.close();
          return;
        }
        if (this._successProduct) this._successProduct.textContent = this.product?.title || '';
        this._success.hidden = false;
        this._panel.classList.add('has-success');
        this._success.focus({ preventScroll: true });
        if (this._closeTimer) clearTimeout(this._closeTimer);
        this._closeTimer = setTimeout(() => {
          this._closeTimer = null;
          this.close();
        }, 1200);
      }

      _resetSuccess() {
        if (this._success) this._success.hidden = true;
        if (this._panel) this._panel.classList.remove('has-success');
      }
    }
    customElements.define('pre-bf-quick-buy', PreBfQuickBuy);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-page-popup-link"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pre-page-popup-link')) {
    class PrePagePopupLink extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.floating = this.querySelector('[data-ppl-floating]');
        this.link = this.querySelector('[data-ppl-link]');
        this.minimizeButton = this.querySelector('[data-ppl-minimize]');
        this.label = this.querySelector('.ppl__label');
        if (!this.floating || !this.link) return;

        // Measure label while the minimized pill is laid out.
        // This keeps the original 320ms width transition smooth.
        if (this.label) {
          this.label.style.setProperty('--ppl-label-width', `${Math.ceil(this.label.scrollWidth)}px`);
        }

        // Extra destination-page protection for different www spellings.
        try {
          const destination = new URL(this.link.href);
          const current = new URL(window.location.href);
          const host = (value) => value.replace(/^www\./i, '');
          const path = (value) => value.replace(/\/+$/, '') || '/';
          if (host(destination.hostname) === host(current.hostname) &&
              path(destination.pathname) === path(current.pathname)) {
            this.style.display = 'none';
            return;
          }
        } catch (error) {
          // Shopify's anchor handles navigation if URL parsing fails.
        }

        this._targetReached = false;
        this._expandedOnce = false;
        this._revealScrollY = null;
        this._lockedMinimized = false;
        this._targetElement = null;
        this._visibilityFrame = null;

        // Preserve the V4 manual-X session choice; auto collapse is not stored.
        if (!window.Shopify || !window.Shopify.designMode) {
          try {
            this._lockedMinimized = sessionStorage.getItem(this.dataset.storageKey) === 'minimized';
          } catch (error) {
            // Private browsing may disallow session storage.
          }
        }
        // Always start with the clickable gift icon and persistent badge.
        this.floating.classList.add('is-minimized');

        this._onMinimize = () => {
          this.minimize(true);
          this.link.focus({ preventScroll: true });
        };
        if (this.minimizeButton) {
          this.minimizeButton.addEventListener('click', this._onMinimize);
        }

        this._onScroll = () => this.scheduleSync();
        this._onResize = () => this.scheduleSync();
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });
        this.scheduleSync();
      }

      disconnectedCallback() {
        if (this.minimizeButton && this._onMinimize) {
          this.minimizeButton.removeEventListener('click', this._onMinimize);
        }
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._visibilityFrame !== null && this._visibilityFrame !== undefined) {
          cancelAnimationFrame(this._visibilityFrame);
        }
        this._visibilityFrame = null;
        this._initialized = false;
      }

      scheduleSync() {
        if (this._visibilityFrame !== null) return;
        this._visibilityFrame = requestAnimationFrame(() => this.syncVisibility());
      }

      findTargetSection() {
        if (this._targetElement && this._targetElement.isConnected) return this._targetElement;
        const id = (this.dataset.targetSectionId || '').trim().replace(/^#/, '');
        this._targetElement = id ? document.getElementById(id) : null;
        return this._targetElement;
      }

      minimize(rememberManualChoice = false) {
        this._lockedMinimized = true;
        this.floating.classList.add('is-minimized');
        if (rememberManualChoice) {
          try {
            sessionStorage.setItem(this.dataset.storageKey, 'minimized');
          } catch (error) {
            // Even without storage, the current page stays minimized.
          }
        }
      }

      syncVisibility() {
        this._visibilityFrame = null;
        if (!this.floating) return;
        const scrollY = window.scrollY || window.pageYOffset || 0;

        // Single Section-based expansion. Without a valid target Section ID,
        // the always-visible gift icon remains minimized and clickable.
        if (!this._targetReached) {
          const target = this.findTargetSection();
          if (target) {
            const rect = target.getBoundingClientRect();
            if (rect.top <= window.innerHeight * 0.85) {
              this._targetReached = true;
              if (!this._lockedMinimized && rect.bottom > 0) {
                this._expandedOnce = true;
                this._revealScrollY = scrollY;
                this.floating.classList.remove('is-minimized');
              } else {
                // Deep scroll restore past the target: show only an icon.
                this.minimize();
              }
            }
          }
        }

        // Auto collapse only after the pill has expanded, measured relative
        // to the expansion location rather than the page's scroll origin.
        if (this._expandedOnce && !this._lockedMinimized) {
          const distance = Math.max(0, Number(this.dataset.autoCollapseDistance) || 400);
          if (scrollY - this._revealScrollY >= distance) {
            this.minimize();
          }
        }
      }
    }
    customElements.define('pre-page-popup-link', PrePagePopupLink);
  }

  } catch(e) { console.error(e); }
})();
})();
